import React, { ComponentState, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { serviceCodeChartModel } from "src/dataModels/docListModel";
import { userIsSuperAdmin, userIsAdmin } from "src/helper/permission-helper";
import { ListView, ListViewHeader } from "@progress/kendo-react-listview";
import CustomSkeleton from "src/control-components/skeleton/skeleton";
import CommonListFilterItem from "./common-list-filter-item";
import { TableRowsLoader } from "src/control-components/custom-skelton";
import { HeaderComponent } from "./header-component";
import { exportDocumentReport, saveExportReportNo, saveShowWithModifier } from "src/redux/actions";
import { Switch } from "@progress/kendo-react-inputs";
import NoteneticButton from "src/control-components/button";

const DocumentsByServiceCode = ()  => {
  const state: ComponentState = useSelector((states) => {
    return states;
  });
  const staffLoginInfo = useSelector(
    (state: ComponentState) => state.getStaffReducer
  );
  const isBillingManager = state.getRolePermission.isBillingManager;
  const [serviceCodeData, setServiceCodeData] = useState<
    serviceCodeChartModel[]
  >([]);
  const { documentByServiceCode, documentByServiceCodeWithModifier, loadingObject, documentReportId, docPayload ,showWithModifier} = state["DocumentReducer"];    
  const userIsSA = userIsSuperAdmin(staffLoginInfo?.roleId);
  const showBillingAmounts = state.getRolePermission.showBillingAmounts;
  const canShowBillData = isBillingManager || userIsSA || showBillingAmounts;
  const dataSource = showWithModifier
    ? documentByServiceCodeWithModifier
    : documentByServiceCode;
  const [isShowItems, setShowItems] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setServiceCodeData([]);
    if (dataSource && dataSource?.resultData) {
      setShowItems(true);
      // Sort the data by 'totDocs' in descending order
      const sortedData = dataSource?.resultData
        ?.slice()
        .sort((a, b) => b.totDocs - a.totDocs);
      sortedData?.map((item) => {
        const totalbillValue = Number(item?.totBilled).toFixed(2);
        const formattedTotalBill = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(Number(totalbillValue));
        var obj: serviceCodeChartModel = {
          id: item?.serviceId,
          serviceCode: item?.serviceCode,
          documents: item?.totDocs,
          totalUnits: item.totalUnits,
          billingAmount: canShowBillData ? formattedTotalBill : "",
        };
        setServiceCodeData((oldItem) => [...oldItem, obj]);
      });
    }
  }, [dataSource, showWithModifier]);

  const handleToggleChange = (e) => {
    const newValue = e.target.value;
    dispatch(saveShowWithModifier(newValue));     
  };

  const DocByServiceCodeHeader = () => {
    return (
      <ListViewHeader
        style={{
          color: "#000000",
          fontSize: 30,
        }}
        className="px-3 py-2 "
      >
        <div className="row border-bottom align-middle">
          <div className="col-3">
            <h2 className="f-14">Service Code</h2>
          </div>
          <div className="col-3">
            <h2 className="f-14"># of Docs</h2>
          </div>
          <div className="col-3">
            <h2 className="f-14">Units</h2>
          </div>
          <div className="col-3">
            <h2 className="f-14 ">Billing Charges</h2>
          </div>
        </div>
      </ListViewHeader>
    );
  };
  const DocByServiceCodeListView = (props) => {
    let item = props.dataItem;
    return (
      <div
        className="row py-2 border-bottom align-middle"
        style={{ margin: 0 }}
      >
        <div className="col-3">
          {!isShowItems ? (
            <CustomSkeleton shape="text" />
          ) : (
            <span className='hover_underline'>    <CommonListFilterItem item={item} type={"service"} /> </span>
          )}
        </div>
        <div className="col-3">
          {!isShowItems ? (
            <CustomSkeleton shape="text" />
          ) : (
            <div>{item?.documents}</div>
          )}
        </div>
        <div className="col-3">
          {!isShowItems ? (
            <CustomSkeleton shape="text" />
          ) : (
            <div>{item?.totalUnits}</div>
          )}
        </div>
        <div className="col-3">
          {!isShowItems ? (
            <CustomSkeleton shape="text" />
          ) : (
            <div>{item?.billingAmount}</div>
          )}
        </div>
      </div>
    );
  };
  const exportToExcel = () => {
    if(showWithModifier){
      dispatch(exportDocumentReport([docPayload, 9]))
      dispatch(saveExportReportNo(9))
    }else{
      dispatch(exportDocumentReport([docPayload, 8]))
      dispatch(saveExportReportNo(8))
    }
  }
  return (
    <>{
      <div className="grid-table filter-grid dash-filter-grid my-3 caseload-custom gridheight boxHeight  topFixHeader docByService">
        <div className="flexBox flex-wrap px-2 pb-3 gy-2">
          <h5 style={{ margin: 0 }} className="order-1 p-0">Documents by Service Code</h5>
          <div className="switch-container blue_theme wordWrapResponsive  order-3 w-100" style={{ display: 'flex', alignItems: 'center' }}>
            <Switch
              checked={showWithModifier}
              onChange={handleToggleChange}
              onLabel={""}
              offLabel={""}
            />
            <span className="switch-label ml-2 f-14">Show w/Modifier</span>
          </div>
         <div className="order-2">
           <NoteneticButton
            preset="bordered"
            text=""
            tooltip="Export to Excel"
            iconName="fa-regular fa-file-excel"
            onClick={exportToExcel}
            isLoading={documentReportId === 8}
            disabled={documentReportId === 8}
          />
         </div>
        </div>
        {(loadingObject?.includes(7)) ? <TableRowsLoader rowsNum={12} /> :
          dataSource?.resultData?.length != 0 ? (
            <ListView
              className="traningList"
              data={serviceCodeData}
              item={DocByServiceCodeListView}
              style={{
                width: "100%",
                display: "block",
              }}
              header={DocByServiceCodeHeader}
            />
          ) : (
            <div className="notFoundData">
             <p>No Record found</p>
             </div>
          )
        }
      </div>
    }</>
  );
};

export default DocumentsByServiceCode;
